/* eslint-disable class-methods-use-this */

class VersionService {
  interval = null;
  name = 'version';
  intervalTime = 1000 * 60 * 60;

  async getNewVersion() {
    const currentUrl = window.location.href;
    const result = await fetch(currentUrl);
    const html = await result.text();
    const parser = new DOMParser();
    const document = parser.parseFromString(html, 'text/html');
    const version = document
      .getElementsByName('version')[0]
      .getAttribute('content');
    return version;
  }

  getOldVersion() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    return localStorage.getItem(name);
  }

  setNewVersion(version) {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    localStorage.setItem(name, version);
  }

  async checkVersion(cb) {
    const newVersion = await this.getNewVersion();
    const oldVersion = this.getOldVersion();
    if (!oldVersion || oldVersion !== newVersion) {
      cb();
      this.setNewVersion(newVersion);
    }
  }

  init(cb) {
    this.checkVersion(cb);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.interval = setInterval(() => this.checkVersion(cb), this.intervalTime);
  }

  destroy() {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    clearInterval(this.interval);
  }
}

export default VersionService;
